import { FC } from 'react'

type Props = {
  className?: string
}

const ExitIcon: FC<Props> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7578 1.76413C13.338 1.543 14.5711 2.05894 14.5713 3.16452V20.8569C14.5713 21.9627 13.338 22.4057 12.7578 22.2583L6.73828 20.562C5.79556 20.3407 5.14258 19.4563 5.14258 18.4243V5.59714C5.14276 4.63898 5.79562 3.68062 6.73828 3.45945L12.7578 1.76413ZM16.75 3.49949C17.9926 3.49949 19 4.45088 19 5.62449V18.3745C19 19.5481 17.9926 20.4995 16.75 20.4995H16V3.49949H16.75ZM12.8574 11.1421C12.8569 10.1843 11.1431 10.1843 11.1426 11.1421V12.8569C11.1427 13.8151 12.8573 13.8151 12.8574 12.8569V11.1421Z"
      fill="#DD524C"
    />
  </svg>
)

export default ExitIcon
